import React, { useState, useEffect } from 'react';
import { dateToLocal, convertDateClientToOperatorUTC } from '../shared/Functions';
import { useParams } from 'react-router';
import { ReadsVService } from '../../services/V2/aurascope';
import { PortalConfigsVService } from '../../services/V2/padre';
import { authProvider } from '../../services/Security';
import { CustomTable } from '../shared/CustomTable';

export const MeterReads = () => {
    const [loading, setLoading] = useState<boolean>(false);
    const [filters, setFilters] = useState<any[]>([]);
    const [token, setToken] = useState<any[]>([]);
    const [formData, setFormData] = useState<any>();
    const [operatorId, setOperatorId] = useState<any>();
    const [offsetInMinutes, setOffsetInMinutes] = useState<number>(-new Date().getTimezoneOffset());
    const { meterId } = useParams<{ meterId: string | undefined }>();

    window.addEventListener('message', event => {
        // IMPORTANT: check the origin of the data!
        if (!event.data) return;
        var data = JSON.parse(event?.data);
        authProvider.setToken(data?.token)
        setFormData(data)
        setToken(data?.token)
        setOperatorId(data?.operatorId)
        // if (event.origin === 'https://your-first-site.example') {
        //     // The data was sent from your site.
        //     // Data sent with postMessage is stored in event.data:
        // } else {
        //     // The data was NOT sent from your site!
        //     // Be careful! Do not use it. This else branch is
        //     // here just for clarity, you usually shouldn't need it.
        //     return;
        // }
    });

    useEffect(() => {
        if (operatorId) {
            PortalConfigsVService.portalConfigsVGetAll(operatorId)
                .then((x: any) => {
                    let offset: number = -new Date().getTimezoneOffset();
                    try {
                        const nowDate = new Date();
                        const tzDate = new Date(nowDate.toLocaleString('en-US', { timeZone: x.timezone }));
                        const calculatedOffset = (nowDate.getTime() - tzDate.getTime()) / 60000;
                        offset = -calculatedOffset;
                    } catch (e) {
                    }
                    setOffsetInMinutes(offset);
                })
                .catch((x) => { });
        }
    }, [operatorId]);

    useEffect(() => {
        let filterArray: any[] = [];
        if (formData?.districtId) filterArray.push({ property: "MeterRoute.DistrictId", value: formData.districtId })
        if (formData?.routeId) filterArray.push({ property: "MeterRouteId", value: formData.routeId })
        if (formData?.meterId) filterArray.push({ property: "MeterId", value: formData.meterId })
        if (formData?.userId) filterArray.push({ property: "UserId", value: formData.userId })
        if (formData?.createdById) filterArray.push({ property: "CreatedBy", value: formData.createdById })
        setFilters(filterArray)
        setLoading(true)
    }, [formData])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (meterId) {
            setLoading(true)
        }
    }, [meterId])

    return (
        <React.Fragment>
            <CustomTable
                title={meterId ? "Meter Reads" : ""}
                columns={[
                    { title: 'Id', field: 'id', hidden: true, export: true },
                    { title: 'Meter Id', field: 'meterId', editable: 'never' },
                    { title: 'Meter Number', field: 'meterNumber', editable: 'never', sorting: false },
                    { title: 'Route Id', field: 'meterRouteId', editable: 'never' },
                    { title: 'Route Name', field: 'meterRouteName', editable: 'never', sorting: false },
                    { title: 'User Id', field: 'userId', hidden: true, export: true },
                    { title: 'User Name', field: 'userName', hidden: true, export: true },
                    { title: 'Message', field: 'message', editable: 'never' },
                    { title: 'Number of Tries', field: 'numTries', editable: 'never' },
                    { title: 'Read', field: 'read', editable: 'never' },
                    { title: 'Read Status', field: 'readStatus', editable: 'never' },
                    { title: 'Read Time', field: 'ReadingDateTime', editable: 'never', render: (rowData: any) => dateToLocal(rowData.readingDateTime).toLocaleString() },
                    { title: 'Created At', field: 'createdAt', hidden: true, export: true },
                    { title: 'Created By', field: 'created', hidden: true, export: true },
                    { title: 'Modified At', field: 'modifiedAt', hidden: true, export: true },
                    { title: 'Modified By', field: 'modified', hidden: true, export: true },
                    { title: 'Customer Name', field: 'customerName', hidden: true, export: true },
                    { title: 'Street', field: 'street', hidden: true, export: true },
                    { title: 'City', field: 'city', hidden: true, export: true },
                    { title: 'State', field: 'state', hidden: true, export: true },
                    { title: 'Zip', field: 'zip', hidden: true, export: true },
                    { title: 'Zip4', field: 'zip4', hidden: true, export: true },
                ]}
                dataEndpoint={query => {
                    return new Promise((resolve, reject) => {
                        if (!token || (!formData?.districtId && !meterId)) {
                            setLoading(false)
                            resolve({
                                data: [],
                                page: query.page,
                                totalCount: 0
                            })
                        } else if (meterId) {
                            ReadsVService.readsVGetAll({
                                pageNumber: query.page + 1,
                                numberPerPage: query.pageSize,
                                orderBy: query?.orderBy?.field?.toString() ?? "Id",
                                orderByDesc: query.orderDirection === "desc",
                                filters: [{
                                    property: "MeterId",
                                    value: meterId
                                }],
                                searchQuery: query.search
                            })
                                .then((r: any) => {
                                    setLoading(false)
                                    resolve({
                                        data: r.items ?? [],
                                        page: query.page,
                                        totalCount: r.numberOfItems ?? 0
                                    })
                                })
                                .catch(err => reject(err))
                        } else {
                            ReadsVService.readsVGetAll({
                                pageNumber: query.page + 1,
                                numberPerPage: query.pageSize,
                                orderBy: query?.orderBy?.field?.toString() ?? "Id",
                                orderByDesc: query.orderDirection === "desc",
                                filters: filters,
                                fromDate: formData.fromReadingDateTime !== "" ? convertDateClientToOperatorUTC(new Date(formData.fromReadingDateTime), offsetInMinutes) : null,
                                toDate: formData.toReadingDateTime !== "" ? convertDateClientToOperatorUTC(new Date(formData.toReadingDateTime), offsetInMinutes) : null
                            })
                                .then((r: any) => {
                                    setLoading(false)
                                    resolve({
                                        data: r.items ?? [],
                                        page: query.page,
                                        totalCount: r.numberOfItems ?? 0
                                    })
                                })
                                .catch(err => reject(err))
                        }
                    })
                }}
                actions={[
                ]}
                refresh={loading} setRefresh={setLoading} pageSize={15} enablePaging={true}
                districtId={null} addedQuery={null} hiddenColumns={[]} setHiddenColumns={() => { }} hiddenColumnsDisabled={true}
                tableHeight={"400px"} enableSearch={false} searchPlaceholder={null} dataSet={null}
            />
        </React.Fragment>
    );
}